import React, { useState,useEffect } from 'react';
import './SignUp.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faUser, faEye, faEyeSlash, faLock, faIdCard, faHome, faPhone } from '@fortawesome/free-solid-svg-icons';
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Alert from "react-bootstrap/Alert";
import axios from 'axios';

const SignUp = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [cin, setCin] = useState('');
  const [nom, setNom] = useState('');
  const [prenom, setPrenom] = useState('');
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const navigate = useNavigate();
  const [errorCinMessage, setCinErrorMessage] = useState(false);
  const [errorNomMessage, setNomErrorMessage] = useState(false);
  const [errorPrenomMessage, setPrenomErrorMessage] = useState(false);
  const [errorUsernameMessage, setUsernameErrorMessage] = useState(false);
  const [errorEmailMessage, setEmailErrorMessage] = useState(false);
  const [errorPhoneMessage, setPhoneErrorMessage] = useState(false);
  const [errorPasswordMessage, setPasswordErrorMessage] = useState(false);
  const [errorConfirmPasswordMessage, setConfirmPasswordErrorMessage] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = (e) => {
    e.preventDefault();


    axios.post('https://stage-cni-backend.vercel.app/signup', {
      cin: cin,
      nom: nom,
      prenom: prenom,
      username: username,
      email: email,
      address: address,
      phoneNumber: phoneNumber,
      password: password,
      confirmPassword: confirmPassword,
    })
      .then((response) => {
        navigate("/EmailVerification");
      })
      .catch((error) => {
        if (error.response.data.errors.cin) {
          setCinErrorMessage(true);
          setNomErrorMessage(false)
          setPrenomErrorMessage(false);
          setUsernameErrorMessage(false);
          setEmailErrorMessage(false);
          setPhoneErrorMessage(false);
          setPasswordErrorMessage(false);
          setConfirmPasswordErrorMessage(false);
        }
        if (error.response.data.errors.nom) {
          setCinErrorMessage(false);
          setNomErrorMessage(true)
          setPrenomErrorMessage(false);
          setUsernameErrorMessage(false);
          setEmailErrorMessage(false);
          setPhoneErrorMessage(false);
          setPasswordErrorMessage(false);
          setConfirmPasswordErrorMessage(false);
        }
        if (error.response.data.errors.prenom) {
          setCinErrorMessage(false);
          setNomErrorMessage(false)
          setPrenomErrorMessage(true);
          setUsernameErrorMessage(false);
          setEmailErrorMessage(false);
          setPhoneErrorMessage(false);
          setPasswordErrorMessage(false);
          setConfirmPasswordErrorMessage(false);
        }
        if (error.response.data.errors.username) {
          setCinErrorMessage(false);
          setNomErrorMessage(false)
          setPrenomErrorMessage(false);
          setUsernameErrorMessage(true);
          setEmailErrorMessage(false);
          setPhoneErrorMessage(false);
          setPasswordErrorMessage(false);
          setConfirmPasswordErrorMessage(false);
        }
        if (error.response.data.errors.email) {
          setCinErrorMessage(false);
          setNomErrorMessage(false)
          setPrenomErrorMessage(false);
          setUsernameErrorMessage(false);
          setEmailErrorMessage(true);
          setPhoneErrorMessage(false);
          setPasswordErrorMessage(false);
          setConfirmPasswordErrorMessage(false);
        }
        if (error.response.data.errors.phoneNumber) {
          setCinErrorMessage(false);
          setNomErrorMessage(false)
          setPrenomErrorMessage(false);
          setUsernameErrorMessage(false);
          setEmailErrorMessage(false);
          setPhoneErrorMessage(true);
          setPasswordErrorMessage(false);
          setConfirmPasswordErrorMessage(false);
        }
        if (error.response.data.errors.password) {
          setCinErrorMessage(false);
          setNomErrorMessage(false)
          setPrenomErrorMessage(false);
          setUsernameErrorMessage(false);
          setEmailErrorMessage(false);
          setPhoneErrorMessage(false);
          setPasswordErrorMessage(true);
          setConfirmPasswordErrorMessage(false);
        }
        if (error.response.data.errors.confirmPassword) {
          setCinErrorMessage(false);
          setNomErrorMessage(false)
          setPrenomErrorMessage(false);
          setUsernameErrorMessage(false);
          setEmailErrorMessage(false);
          setPhoneErrorMessage(false);
          setPasswordErrorMessage(false);
          setConfirmPasswordErrorMessage(true);
        }
      });

  };
  useEffect(() => {
    document.body.classList.add('fade-in-slide-up');
    return () => {
      document.body.classList.remove('fade-in-slide-up');
    };
  }, []);

  return (
    <div className="background-image overflow-hidden">
      <style>
        {`
          .background-image {
            background-image: url('../assetsTemplates/template1/img/carousel-3.jpg');
            background-size: cover;
            background-position: center;
          }
        `}
      </style>

      <div className="wrapper">
        <div className="container px-4 py-5 px-md-5 text-center text-lg-start my-5">
          <div className="row gx-lg-5 align-items-center mb-5">
            <div className="col-lg-6 mb-5 mb-lg-0" style={{ zIndex: 10 }}>
            </div>
            <div className="col-lg-6 mb-5 mb-lg-0 position-relative">
              <div id="radius-shape-1" className="position-absolute rounded-circle shadow-5-strong"></div>
              <div id="radius-shape-2" className="position-absolute shadow-5-strong"></div>

              <div className="card bg-glass">
                <div className="card-body px-4 py-5 px-md-5">
                  <div className="text-center my-5">
                    <h3 className="font-weight-bold mb-3">Sign Up</h3>
                    <h3 className="text-muted font-italic fs-5">Create your account now</h3>
                  </div>
                  <form onSubmit={handleSubmit}>
                    <div className="form-outline mb-4">
                      <div className="input-wrapper">
                        <input
                          type="number"
                          id="cin"
                          className="form-control"
                          placeholder="CIN"
                          required
                          value={cin}
                          onChange={(e) => setCin(e.target.value)}
                        />
                        <FontAwesomeIcon icon={faIdCard} className="toggle" />
                      </div>
                    </div>
                    {errorCinMessage && (
                      <Alert
                        className="form-group"
                        variant="danger"
                        style={{ marginTop: "-13px" }}
                      >
                        <div
                          className="form-icon-wrapper  text-danger"
                          style={{ marginTop: "-11px", marginBottom: "-13px" }}>
                          CIN already exists
                        </div>
                      </Alert>
                    )}
                    <div className="row mb-4">
                      <div className="col-md-6">
                        <div className="form-outline">
                          <input
                            type="text"
                            id="firstName"
                            className="form-control"
                            placeholder="First Name"
                            required
                            value={nom}
                            onChange={(e) => setNom(e.target.value)}
                          />
                        </div>
                        {errorNomMessage && (
                          <Alert
                            className="form-group"
                            variant="danger"
                            style={{ marginTop: "10px", marginBottom: "-13px" }}
                          >
                            <div
                              className="form-icon-wrapper  text-danger"
                              style={{ marginTop: "-11px", marginBottom: "-13px" }}>
                              Invalid nom
                            </div>
                          </Alert>
                        )}
                      </div>

                      <div className="col-md-6">
                        <div className="form-outline">
                          <input
                            type="text"
                            id="lastName"
                            className="form-control"
                            placeholder="Last Name"
                            required
                            value={prenom}
                            onChange={(e) => setPrenom(e.target.value)}
                          />
                        </div>
                        {errorPrenomMessage && (
                          <Alert
                            className="form-group"
                            variant="danger"
                            style={{ marginTop: "10px", marginBottom: "-13px" }}
                          >
                            <div
                              className="form-icon-wrapper  text-danger"
                              style={{ marginTop: "-11px", marginBottom: "-13px" }}>
                              Invalid Prenom
                            </div>
                          </Alert>
                        )}
                      </div>
                    </div>

                    <div className="form-outline mb-4">
                      <div className="input-wrapper">
                        <input
                          type="text"
                          id="username"
                          className="form-control"
                          placeholder="Username"
                          required
                          value={username}
                          onChange={(e) => setUsername(e.target.value)}
                        />
                        <FontAwesomeIcon icon={faUser} className="toggle" />
                      </div>
                    </div>
                    {errorUsernameMessage && (
                      <Alert
                        className="form-group"
                        variant="danger"
                        style={{ marginTop: "-13px" }}
                      >
                        <div
                          className="form-icon-wrapper  text-danger"
                          style={{ marginTop: "-11px", marginBottom: "-13px" }}>
                          Invalid username
                        </div>
                      </Alert>
                    )}


                    <div className="form-outline mb-4">
                      <div className="input-wrapper">
                        <input
                          type="text"
                          id="livingAddress"
                          className="form-control"
                          placeholder="Living Address"
                          required
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                        />
                        <FontAwesomeIcon icon={faHome} className="toggle" />
                      </div>
                    </div>

                    <div className="form-outline mb-4">
                      <div className="input-wrapper">
                        <input
                          type="email"
                          id="email"
                          className="form-control"
                          placeholder="Email Address"
                          required
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                        <FontAwesomeIcon icon={faEnvelope} className="toggle" />
                      </div>
                      {errorEmailMessage && (
                      <Alert
                        className="form-group"
                        variant="danger"
                        style={{ marginTop: "10px", marginBottom: "-13px" }}
                      >
                        <div
                          className="form-icon-wrapper  text-danger"
                          style={{ marginTop: "-11px", marginBottom: "-13px" }}>
                          Email already exists
                        </div>
                      </Alert>
                    )}
                    </div>


                    <div className="form-outline mb-4">
                      <div className="input-wrapper">
                        <input
                          type="tel"
                          id="phoneNumber"
                          className="form-control"
                          placeholder="Phone Number"
                          required
                          value={phoneNumber}
                          onChange={(e) => setPhoneNumber(e.target.value)}
                        />
                        <FontAwesomeIcon icon={faPhone} className="toggle" />
                      </div>
                    </div>
                    {errorPhoneMessage && (
                      <Alert
                        className="form-group"
                        variant="danger"
                        style={{ marginTop: "-13px" }}
                      >
                        <div
                          className="form-icon-wrapper  text-danger"
                          style={{ marginTop: "-11px", marginBottom: "-13px" }}>
                          Invalid phone number
                        </div>
                      </Alert>
                    )}

                    <div className="form-outline mb-4">
                      <div className="input-wrapper">
                        <input
                          type={showPassword ? 'text' : 'password'}
                          id="password"
                          className="form-control"
                          placeholder="Password"
                          required
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        <FontAwesomeIcon
                          icon={showPassword ? faEyeSlash : faEye}
                          className="toggle"
                          onClick={togglePasswordVisibility}
                        />
                      </div>
                      {errorPasswordMessage && (
                      <Alert
                        className="form-group"
                        variant="danger"
                        style={{ marginTop: "10px", marginBottom: "-13px" }}
                      >
                        <div
                          className="form-icon-wrapper  text-danger"
                          style={{ marginTop: "-11px", marginBottom: "-13px" }}>
                          Invalid password. The password must contain at least one uppercase letter and one number
                        </div>
                      </Alert>
                    )}
                    </div>


                    <div className="form-outline mb-4">
                      <div className="input-wrapper">
                        <input
                          type="password"
                          id="confirmepassword"
                          className="form-control"
                          placeholder="Confirm your password"
                          required
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                        <FontAwesomeIcon icon={faLock} className="toggle" />
                      </div>
                      {errorConfirmPasswordMessage && (
                      <Alert
                        className="form-group"
                        variant="danger"
                        style={{ marginTop: "10px", marginBottom: "-13px" }}
                      >
                        <div
                          className="form-icon-wrapper  text-danger"
                          style={{ marginTop: "-11px", marginBottom: "-13px" }}>
                          Password and confirmPassword do not match
                        </div>
                      </Alert>
                    )}
                    </div>

                    <button type="submit" className="btn btn-primary btn-block mb-4">
                      Sign Up
                    </button>
                  </form>

                  <div className="text-center">
                    <p>
                      Already have an account? <NavLink to="/SignIn">Sign In</NavLink>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
